import type { ReactElement } from 'react';
import { Outlet } from 'react-router';
import { Auth0ProviderWithNavigate } from '@/components/auth/Auth0ProviderWithNavigate';
import { ScrollManager } from '@/components/layout/ScrollManager';
import { ApiProvider } from '@/lib/api-provider';

/**
 * Layout raíz: provee Auth0 + ApiClient a TODA la app. Debe vivir DENTRO del
 * Router porque Auth0ProviderWithNavigate usa useNavigate.
 */
export function Root(): ReactElement {
  return (
    <Auth0ProviderWithNavigate>
      <ApiProvider>
        {/* G4: al cambiar de pantalla abre arriba; atrás conserva la posición. */}
        <ScrollManager />
        <Outlet />
      </ApiProvider>
    </Auth0ProviderWithNavigate>
  );
}
